import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './api/msalConfig';
import App from './App';
import { SettingsProvider } from './contexts/SettingsContext';
import './index.css';

const msalInstance = new PublicClientApplication(msalConfig);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js');
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <SettingsProvider>
          <App />
        </SettingsProvider>
      </MsalProvider>
    </BrowserRouter>
  </React.StrictMode>
);
